<template>
  <div>
    <div class="event-row" @click="setExpandId(item.id)">
      <div class="column" :style="{'width': getColumnWidth.eventName.size != 0 ? getColumnWidth.eventName.size + 'px' : '12%'}">
        <div class="content column-name">
          <div class="icon-status">
            <div class="calendar-checked-icon"></div>
          </div>
          <div class="info">
            <div class="client-name">
              {{item.clientName}}
            </div>
            <div class="event-name">
              {{item.eventName}}
            </div>
          </div>
        </div>
      </div>
      <div class="column" :style="{'width': getColumnWidth.projPart.size != 0 ? getColumnWidth.projPart.size + 'px' : '6%'}">
        <div class="content">
          {{item.projPart}}
        </div>
      </div>
      <div class="column" :style="{'width': getColumnWidth.fullAddress.size != 0 ? getColumnWidth.fullAddress.size + 'px' : '26%'}">
        <div class="content">
          {{item.fullAddress}}
        </div>
      </div>
      <div class="column" :style="{'width': getColumnWidth.eventLocation.size != 0 ? getColumnWidth.eventLocation.size + 'px' : '8%'}">
        <div class="content">
          {{item.eventLocation}}
        </div>
      </div>
      <div class="column" :style="{'width': getColumnWidth.startTime.size != 0 ? getColumnWidth.startTime.size + 'px' : '7%'}">
        <div class="content">
          {{item.startTime}}
        </div>
      </div>
      <div class="column" :style="{'width': getColumnWidth.duration.size != 0 ? getColumnWidth.duration.size + 'px' : '5%'}">
        <div class="content">
          {{item.duration}}
        </div>
      </div>
      <div class="column" :style="{'width': getColumnWidth.endTime.size != 0 ? getColumnWidth.endTime.size + 'px' : '7%'}">
        <div class="content">
          {{item.endTime}}
        </div>
      </div>
      <div class="column" :style="{'width': getColumnWidth.timeZone.size != 0 ? getColumnWidth.timeZone.size + 'px' : '4%'}">
        <div class="content">
          {{item.timeZone}}
        </div>
      </div>
      <div class="column" :style="{'width': getColumnWidth.contactName.size != 0 ? getColumnWidth.contactName.size + 'px' : '9%'}">
        <div class="content">
          {{item.contactName}}</div>
      </div>
      <div class="column" :style="{'width': getColumnWidth.prefDate.size  != 0? getColumnWidth.action.size + 'px' : '11%'}">
        <div class="content">
          {{item.prefDate}}
        </div>
      </div>
      <div class="btn-func">
        <Icon class="icon-btn-func" name="ellipsis-v"></Icon>
      </div>
    </div>
      <div class="displayNone" :class="{'openContent': item.id == getId}">
        <div class="dt-row-item-detail">
          <div class="item-detail-header">
            <div class="row">
              <div class="col-sm-3 padding-left-71 padding-top-9px">alerts</div>
              <div class="col-sm-4 padding-left-27 padding-top-9px">event notes</div>
              <div class="col-sm-3 padding-top-9px">on site contact</div>
              <div class="col-sm-2 padding-top-9px">add on services</div>
            </div>
          </div>
          <div class="item-detail-body">
            <div class="row">
              <div class="col-sm-3">
                <div v-if="item.isChangeOrder" class="row li-red">
                  <div class="col-sm-1 icon-alert">
                    <Icon name="exclamation-circle"
                          class="row-detail-icon row-detail-icon-exclamation-circle circle-red"></Icon>
                  </div>
                  <div class="col-sm-11 text-alert">
                    <span class="alert-note">This item approved as a change order. Check change notes and contract details.</span>
                  </div>
                </div>
                <div v-if="item.projPart < 33" class="row">
                  <div class="col-sm-1 icon-alert">
                    <Icon name="exclamation-circle" class="row-detail-icon row-detail-icon-exclamation-circle"></Icon>
                  </div>
                  <div class="col-sm-11 text-alert">
                    <span class="alert-note">Your estimated participation is low. Consider using small site event.</span>
                  </div>
                </div>
                <div v-if="item.projPart > 200" class="row">
                  <div class="col-sm-1 icon-alert">
                    <Icon name="exclamation-circle" class="row-detail-icon row-detail-icon-exclamation-circle"></Icon>
                  </div>
                  <div class="col-sm-11 text-alert">
                    <span class="alert-note">Your estimated participation is high. Break event into 2 days.</span>
                  </div>
                </div>
                <div v-if="disableIconContact" class="row">
                  <div class="col-sm-1 icon-alert">
                    <Icon name="exclamation-circle" class="row-detail-icon row-detail-icon-exclamation-circle"></Icon>
                  </div>
                  <div class="col-sm-11 text-alert">
                  <span
                    class="alert-note">Missing (email, phone number, email and phone number) for on site contact.</span>
                  </div>
                </div>
                <div v-if="enableIconDuration" class="row">
                  <div class="col-sm-1 icon-alert">
                    <Icon name="exclamation-circle" class="row-detail-icon row-detail-icon-exclamation-circle"></Icon>
                  </div>
                  <div class="col-sm-11 text-alert">
                    <span class="alert-note">Standard events can only be submitted with durations between 4 - 8 hours. To request an event outside of this range please contact ADURO.</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="notes-field">
                  <div class="text-label">
                    shipping address
                    <span class="grey-3 label-address">(if different)</span>
                  </div>
                  <div class="text-value">
                    <vue-google-autocomplete name="shipping-address" :id="'shipping_' + index"
                                             classname="additional-comments shipping-address"
                                             :country="['us']" :item="item"
                                             :disabled="!editable"></vue-google-autocomplete>
                  </div>
                </div>
                <div class="notes-field">
                  <div class="text-label">
                    Additional comments
                  </div>
                  <!--<div style="display: none;">{{item}}</div>-->
                  <div class="text-value">
                  <textarea name="additional-comments"
                            v-model="item.additionalComments" class="additional-comments"
                            :disabled="!editable"></textarea>
                  </div>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="text-contact grey-3">
                  <div class="label">Name</div>
                  <div class="contactName">
                    <input v-model="item.contactName"
                           class="phoneAndEmail"
                           placeholder="Contact name" :disabled="!editable"/>
                  </div>
                </div>
                <div class="text-contact grey-3">
                  <div class="label">Email</div>
                  <div>
                    <input v-model="item.email"
                              class="phoneAndEmail"
                              placeholder="E.g. hannah_welch@gmail.com" :disabled="!editable"/>
                  </div>
                </div>
                <div class="text-contact grey-3">
                  <div class="label">Phone</div>
                  <the-mask mask="(###) ###-####"
                            v-model="item.phone"
                            class="phoneAndEmail"
                            :masked="isTrue"
                            placeholder="(123) 123-1234"
                            :disabled="!editable"></the-mask>
                </div>
              </div>
              <div class="add-on-wrapper col-sm-2">
                <div v-for="(itemAddOn, index) in item.additionalServices" :key="index" class="add-on-item">
                  <div class="">
                    <input type="checkbox" :id="itemAddOn.key + '_' +item.id"
                           v-model="itemAddOn.value"
                           :disabled="disableAdditionalServices"
                    />
                    <label :for="itemAddOn.key + '_' +item.id" :class="{'add-on-off-checkbox': !itemAddOn.isShow}">Toggle</label>
                  </div>
                  <div class="text" :class="{'add-on-off-text': !itemAddOn.isShow}">{{ itemAddOn.text}}</div>
                </div>
              </div>
            </div>
            <!-- BUTTON FUNCTION GROUP -->
            <div class="func-group">
              <DataTableGroupBtn :isLocked="isLocked" :showOnModal="showOnModal" :editEventAdmin="editEventAdmin"
                                 :viewMode="viewMode" :eventStatus="eventStatus" :item="item"
                                 :isSuggestChanges="suggestChanges"></DataTableGroupBtn>
            </div>
            <!-- END: BUTTON FUNCTION GROUP -->
          </div>
        </div>
      </div>
  </div>
</template>

<script>
  // import constants from '../../_consts';
  import 'vue-awesome/icons/ellipsis-v';
  import Icon from 'vue-awesome/components/Icon';
  import {mapMutations, mapGetters} from 'vuex';
  import VueGoogleAutocomplete from 'vue-google-autocomplete';
  import {TheMask} from '../utils/vue-the-mask';
  import DataTableGroupBtn from './DataTableGroupBtn';

  export default {
    name: 'event-row',
    components: {
      Icon,
      VueGoogleAutocomplete,
      TheMask,
      DataTableGroupBtn
    },
    props: {
      index: {
        type: Number,
        default: -1
      },
      item: {
        type: Object,
        default: []
      }
    },
    data () {
      return {
        isLoading: false,
        isDisplay: false,
        editable: false,
        isLocked: false,
        showOnModal: false,
        editEventAdmin: false,
        viewMode: false,
        suggestChanges: false
      }
    },
    computed: {
      ...mapGetters({
        getId: 'GETTERS_GET_EXPAND_ID',
        getColumnWidth: 'GETTERS_GET_COLUMN_WIDTH'
      }),
      enableIconDuration () {
        return this.item.duration < 4 || this.item.duration > 8;
      },
      disableIconContact () {
        return !(this.item.email !== '' && this.item.phone !== '' && this.item.contactName !== '');
      },
      disableAdditionalServices () {
        return true;
      }
    },
    methods: {
      setExpandId (id) {
        this.setIdToState(id);
      },
      ...mapMutations({
        setIdToState: 'MUTATION_SET_EXPAND_ID'
      })
    },
    mounted: function () {
    }
  }
</script>

<style lang="less">
  @import '~@/styles/variables.less';
  .openContent {
    height: 348px !important;
    transition: height ease 0.5s;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    box-shadow: 0 0 1px 0 rgba(0,0,0,0.2), 0 2px 1px 1px rgba(0,0,0,0.1);
    .dt-row-item-detail {
      clear: both;
      .item-detail-header {
        text-transform: uppercase;
        font-size: 12px;
        line-height: 16px;
        border-bottom: solid 1px @grey-2;
        height: 34px;
        background-color: @grey-1;
        font-family: "Open Sans",serif;
        color: @white;
        letter-spacing: 0.1px;
      }
      .item-detail-body {
        background-color: @white;
        padding: 20px 10px 15px 20px;
        height: 314px;
        .row-detail-icon-exclamation-circle {
          height: 14px;
          width: 14px;
          border-radius: 6px;
          padding: 0;
          color: @blue;
          background-color: @white;
          overflow: visible;
        }
        .icon-alert {
          padding: 2px 0 0 22px;
        }
        .text-alert {
          font-family: @font-family-main;
          font-size: 12px;
          padding: 0 20px 0 15px;
          color: @black-2;
          .alert-note {
            // margin-left: -15px;
          }
        }
        .notes-field {
          margin-top: 20px;
          &:first-child {
            margin-top: 0;
          }
          .text-label {
            font-size: 12px;
            text-transform: capitalize;
            line-height: 18px;
            font-family: @font-family-main;
            color: @grey-8;
            .label-address{
              color: @grey-8;
            }
          }
          .text-value {
            .shipping-address {
              width: 100%;
              border: solid 1px @grey-3;
              border-radius: 4px;
              height: 32px;
              font-size: 12px;
              font-family: @font-family-main;
              color: @grey-8;
              padding-left: 16px;
              background-color: @white;

            }
            textarea {
              width: 100%;
              border-radius: 4px;
              border: solid 1px @grey-3;
              padding: 5px 10px;
              background-color: @white;

              &.custom-notes {
                height: 55px;
                padding-left: 14px;
                color: @black;
              }
              &.additional-comments {
                height: 58px;
                padding-left: 14px;
                font-size: 12px;
                font-family: @font-family-main;
                color: @grey-8;
              }
            }
          }
        }
        .text-contact {
          margin-bottom: 20px;
          margin-right: 10px;
          .phoneAndEmail {
            height: 32px;
            border: 1px solid @grey-3;
            border-radius: 4px;
            font-family: @font-family-main;
            padding: 0 0 0 13px;
            font-size: 12px;
            color: @grey-8;
            background-color: @white;
          }
          .label{
            color: @black-1;
            font-family: @font-family-main;
            font-size: 12px;
            text-transform: capitalize;
            line-height: 18px;
          }
          .contactName{
            line-height: 31px;
          }
          // &:first-child {
          //   margin-top: 0;
          // }
        }
        .add-on-off-text {
          color: @grey-4 !important;
        }
        .add-on-off-checkbox {
          border: 1.5px solid rgba(0, 0, 0, 0.02) !important;
        }
        .add-on-off-checkbox:after {
          border: 1.5px solid rgba(0, 0, 0, 0.02) !important;
        }
        .add-on-wrapper {
          .add-on-item {
            margin-left: 0;
            margin-top: 8px;
            height: 20px;
            display: flex;

            .text {
              color: @black-2;
              font-family: "Open Sans",serif;
              font-size: 12px;
              display: inline;
              margin-left: 8px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            input[type=checkbox] {
              height: 0;
              width: 0;
              visibility: hidden;
            }
            label {
              cursor: pointer;
              text-indent: -9999px;
              width: 32px;
              height: 18px;
              background: #fff;
              border-radius: 15.5px;
              position: relative;
              top: 1.5px;
              left: 5px;
              border: 1.5px solid rgba(0, 0, 0, 0.1);
              margin-bottom: 0;
            }

            label:after {
              content: '';
              position: absolute;
              top: -0.5px;
              left: -0.5px;
              width: 16px;
              height: 16px;
              background: #fff;
              border-radius: 15.5px;
              -webkit-transition: 0.3s;
              transition: 0.3s;
              border: 0.5px solid rgba(0, 0, 0, 0.1);

            }

            input:checked + label {
              background: #0080A5;
              border: 1.5px solid #0080A5;
              // border: none;
            }

            input:checked + label:after {
              // top: -0.5px;
              left: calc(100% - 0px);
              transform: translateX(-100%);
              box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);
            }

            label:active:after {
              width: 15px;
            }
          }
        }
        .func-group {
          // text-align: right;
          // position: absolute;
          // bottom: 0;
          // right: 20px;
          button {
            font-size: 14px;
            height: 39px;
            // margin-left: 10px;
            font-family: @font-family-main;
            text-transform: uppercase;
            .func-icon {
              width: 18px;
              height: 18px;
              color: @white;
              float: left;
              // margin-top: 2px;
            }
          }
          .grey-3 {
            color: @grey-3;
          }
        }
      }
    }
  }
  .displayNone {
    height: 0;
    overflow: hidden;
    transition: height ease 0.5s;
  }
  .event-row {
    height: 56px;
    background-color: @white;
    border-radius: 4px;
    box-shadow: 0 0 1px 0 rgba(0,0,0,0.2), 0 2px 1px 1px rgba(0,0,0,0.1);
    color: @black-3;
    font-family: @font-family-main;
    font-size: 12px;
    line-height: 16px;
    position: relative;
    .column{
    float: left;
      .content{
        padding: 20px 0 0 8px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;

        &.column-name{
          padding: 12px 0 0 8px;
          display: flex;
          overflow: hidden;
        }
        .info{
          .client-name{
            color: @grey-9;
            font-family: @font-family-main;
            font-size: 12px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          .event-name{
            color: @black-3;
            font-family: @font-family-main;
            font-size: 12px;
            line-height: 16px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }
        .icon-status{
          width: 24px;
          float: left;
          margin-top: 4px;
          margin-right: 8px;
          .calendar-checked-icon{
            z-index: 7;
            width: 24px;
            height: 24px;
            background-color: @grey-1;
            color: @grey-1;
            -webkit-mask: url('../../../static/img/calendar-checked.svg') no-repeat center;
            mask: url('../../../static/img/calendar-checked.svg') no-repeat center;
            background: url('../../../static/img/calendar-checked-grey.svg') no-repeat center;
          }
        }
      }
    }
    .btn-func{
      position: absolute;
      right: 0;
      top: 20px;
      .icon-btn-func{
        width: 24px;
        height: 24px;
        color: @grey-7;
      }
    }
  }
  .li-red {
    &:before {
      color: @red !important;
    }
  }
  .padding-left-71 {
    padding-left: 71px;
  }

  .padding-left-27 {
    padding-left: 27px;
  }
  .padding-top-9px {
    padding-top: 9px;
  }
</style>



// WEBPACK FOOTER //
// EventRow.vue?099ed777